import { Star } from 'lucide-react';
import { TrustpilotStar } from '@/components/ReviewRow';

// Public review ratings checked on both business profiles on 2026-10-07.
// Customer-review average across the rebrand, NOT either profile's TrustScore.
// This dated snapshot does not update automatically.
const sources = [
  { business: 'ServiceproJylland', ratings: [5, 5, 5, 5, 5, 5] },
  { business: 'E Service', ratings: [5, 5] },
];
const ratings = sources.flatMap((source) => source.ratings);
export const TRUSTPILOT_SNAPSHOT = {
  score: ratings.reduce((sum, value) => sum + value, 0) / ratings.length,
  reviews: ratings.length,
  checkedAt: '2026-10-07',
};

export const TrustpilotSummary = () => (
  <div className="e-hero-trustpilot" data-testid="hero-trustpilot-widget" title="Kundernes gennemsnit på tværs af E Service og ServiceproJylland. Kontrolleret 7. oktober 2026. Ikke Trustpilots beregnede TrustScore.">
    <div className="e-trustpilot-brand"><TrustpilotStar /><span>Trustpilot</span></div>
    <div className="e-trustpilot-stars" role="img" aria-label="Kundernes gennemsnit: 5 ud af 5 stjerner fra 8 anmeldelser samlet for E Service og tidligere ServiceproJylland." data-testid="hero-trustpilot-stars">
      {Array.from({ length: 5 }, (_, i) => <span key={i} className={i < TRUSTPILOT_SNAPSHOT.score ? 'filled' : ''}><Star size={15} fill="currentColor" strokeWidth={0} aria-hidden="true" /></span>)}
    </div>
    <span className="e-trustpilot-score" data-testid="hero-trustpilot-score">Kundernes gennemsnit: {TRUSTPILOT_SNAPSHOT.score.toLocaleString('da-DK')}/5 · {TRUSTPILOT_SNAPSHOT.reviews} anmeldelser</span>
  </div>
);